export const emitResponse = (data, error, status) => {
  return {
    data,
    error,
    status,
  };
};
